import { Box, Grid, Typography } from '@material-ui/core'
import AutorenewIcon from '@material-ui/icons/Autorenew'

interface BoxedGridItemProps {
  heading: React.ReactNode
  value: React.ReactNode
  classes: any
  isEta?: boolean
  className?: string
}

export const BoxedGridItem = ({
  heading,
  value,
  isEta = false,
  classes,
  className = '',
}: BoxedGridItemProps) => (
  <Grid item className={className}>
    <Box display="flex" flexDirection="row">
      <Typography variant="body2" className={classes.heading}>
        {heading}
      </Typography>
      <Typography variant="body2">{value}</Typography>
      {isEta && <AutorenewIcon className={classes.etaIcon} />}
    </Box>
  </Grid>
)
